import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AlarmManagementState } from '@states/alarm-mangment/alarm-management.reducer';

export const selectAlarmsState = createFeatureSelector<AlarmManagementState>('alarmManagementState');

export const selectActiveAlarms = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.activeAlarms
);

export const selectCanceledAlarms = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.canceledAlarms
);

export const selectAllAlarms = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.allAlarms
);

export const selectSelectedAlarm = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.selectedAlarm
);

export const selectCheckResult = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.checkResult
);

export const selectCurrentFilter = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.currentFilter
);

export const selectIsLoading = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.isLoading
);

export const selectError = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.error
);

export const selectActiveAlarmsCount = createSelector(
  selectActiveAlarms,
  (alarms) => alarms.length
);

export const selectHasActiveAlarms = createSelector(
  selectActiveAlarms,
  (alarms) => alarms.length > 0
);

// New selectors for alert instances
export const selectAlarmsWithAlerts = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.alarmsWithAlerts
);

export const selectAlarmsWithAlertsTotal = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.alarmsWithAlertsTotal
);

export const selectAlarmAlertInstances = (alarmId: string) => createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.alarmAlertInstances[alarmId] || []
);

export const selectAlarmAlertInstancesTotal = (alarmId: string) => createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.alarmAlertInstancesTotal[alarmId] || 0
);

export const selectNoonlightActivities = (alertInstanceId: number) => createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.noonlightActivities[alertInstanceId] || []
);

export const selectRejectedAlerts = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.rejectedAlerts
);

export const selectRejectedAlertsTotal = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.rejectedAlertsTotal
);

export const selectRejectedAlertsLimit = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.rejectedAlertsLimit
);

export const selectRejectedAlertsOffset = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.rejectedAlertsOffset
);

export const selectRejectedAlertsLoading = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.rejectedAlertsLoading
);

export const selectRejectedAlertsPagination = createSelector(
  selectRejectedAlertsTotal,
  selectRejectedAlertsLimit,
  selectRejectedAlertsOffset,
  (total, limit, offset) => ({ total, limit, offset, pageIndex: Math.floor(offset / limit) })
);

export const selectSelectedTab = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.selectedTab
);

export const selectExpandedAlarmIds = createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.expandedAlarmIds
);

export const selectIsAlarmExpanded = (alarmId: string) => createSelector(
  selectExpandedAlarmIds,
  (expandedIds) => expandedIds.includes(alarmId)
);

export const selectAlertInstancesLoading = (alarmId: string) => createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.alertInstancesLoading[alarmId] || false
);

export const selectNoonlightActivityLoading = (alertInstanceId: number) => createSelector(
  selectAlarmsState,
  (state: AlarmManagementState) => state.noonlightActivityLoading[alertInstanceId] || false
);
